import { Window } from "../Window.js";
import "./VideoPlayerShortcuts.css";

export { VideoPlayerShortcuts };

/**
 * Init a Window popup to display video player shortcuts
 * @memberof vef.ui.media
 * @extends Window
 * @author ckraemme <ckraemme@awi.de>
 * @author rhess <robin.hess@awi.de>
 * @private
 */
class VideoPlayerShortcuts extends Window {

    mapping = [
        {
            k: ["Space", "Enter"],
            v: "Toogle play"
        },
        {
            k: ["f"],
            v: "Toogle full screen mode"
        },
        {
            k: ["m"],
            v: "Toogle mute"
        },
        {
            k: ["ArrowUp"],
            v: "Increase audio"
        },
        {
            k: ["ArrowDown"],
            v: "Decrease audio"
        },
        {
            k: ["ArrowLeft"],
            v: "Skip back 10 s"
        },
        {
            k: ["ArrowRight"],
            v: "Skip forward 10 s"
        },
        {
            k: [","],
            v: "Skip back 0.05 s"
        },
        {
            k: ["."],
            v: "Skip forward 0.05 s"
        },
        {
            k: [":"],
            v: "Increase playback rate"
        },
        {
            k: [";"],
            v: "Decrease playback rate"
        }
    ]

    /**
     * Show a video player shortcut button including an icon that opens the shortcut table as a popup in a separate window 
     */
    constructor() {
        super(null, {
            title: "<i class='fas fa-keyboard'></i> Video Player Shortcuts",
            draggable: true,
            open: false,
            width: "370px"
        });

        const content = this.mapping.reduce((html, item) => {
            const k = `<kbd>${item.k.join("</kbd> or <kbd>")}</kbd>`;
            const v = item.v;
            return html + `<tr><td>${k}</td><td>${v}</td></tr>`;
        }, "");

        this.setContent(`<table class="video-player-shortcuts"><tbody>${content}</tbody></table>`);

    }

    open() {
        super.open();
        super.center();
        this.isOpened = true;
    }

    close() {
        super.close();
        this.isOpened = false;
    }
}
